import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import {AuthGuard} from "@core/guards/auth.guard";
import { LandingComponent } from './features/auth/pages/landing/landing.component';
import { ReleaseNotesComponent } from './features/release-notes/release-notes.component';

const routes: Routes = [
  {
    path: "",
    component: LandingComponent
  },
  {
    // Public: reachable from the landing page without signing in.
    path: "whats-new",
    component: ReleaseNotesComponent
  },
  {
    path: "auth",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./features/auth/auth.module").then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "people",
        loadChildren: () =>
          import("./features/user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: "device",
        loadChildren: () =>
          import("./features/device/device.module").then((m) => m.DeviceModule),
      },
      {
        path: "restriction",
        loadChildren: () =>
          import("./features/restriction/restriction.module").then(
            (m) => m.RestrictionModule
          ),
      },
      {
        path: "school-calendar",
        loadChildren: () =>
          import("./features/school-calendar/school-calendar.module").then(
            (m) => m.SchoolCalendarModule
          ),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./features/settings/settings.module").then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: "dashboards",
        loadChildren: () =>
          import("./features/dashboards/dashboards.module").then(
            (m) => m.DashboardsModule
          ),
      },
      {
        path: "help",
        loadChildren: () =>
          import("./features/help/help.module").then((m) => m.HelpModule),
      },
      // "main" never existed as a route, so this used to fall through to ** → signup.
      { path: "", redirectTo: "dashboards", pathMatch: "full" },
    ],
  },
  { path: "**", redirectTo: "auth/signup" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
